import { render, staticRenderFns } from "./CulturalFitTab.vue?vue&type=template&id=06588ef6&scoped=true"
import script from "./CulturalFitTab.vue?vue&type=script&lang=js"
export * from "./CulturalFitTab.vue?vue&type=script&lang=js"
import style0 from "./CulturalFitTab.vue?vue&type=style&index=0&id=06588ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06588ef6",
  null
  
)

export default component.exports